<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.GroupMapping.Header' | translate:'Group Mappings' }}">
    @if (!loading) {

    <div class="gm-row">
      <mat-form-field appearance="fill" class="gm-field">
        <mat-label>Group</mat-label>
        <mat-select [(value)]="selectedGroupId" (valueChange)="onGroupSelectionChanged()">
          @for (g of groups; track g) {
          <mat-option [value]="g.Id">{{ g.Name + " (" + g.Id + ")"}}</mat-option>
          }
        </mat-select>
        @if (selectedGroupId != null) {
        <button mat-icon-button matSuffix type="button" aria-label="Clear group" (click)="selectedGroupId = null; onGroupSelectionChanged()">
          <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="gm-field">
        <mat-label>Price list</mat-label>
        <mat-select [(value)]="selectedPriceListTitle" (valueChange)="onPriceListSelectionChanged()">
         @for (pl of availablePriceLists; track pl.Id) {
          <mat-option [value]="pl.Title">{{ pl.Title  + " (" + pl.Id + ")"}}</mat-option>
          }
        </mat-select>
        @if (selectedPriceListTitle != null) {
        <button mat-icon-button matSuffix type="button" aria-label="Clear price list" (click)="selectedPriceListTitle = null; onPriceListSelectionChanged()">
          <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>
    </div>



    @if (selectedGroupId != null && selectedPriceListTitle == null) {
    <div class="mapping-list">

      @if (mappingsForSelectedGroup?.length > 0) {
      <h1>Current Chains</h1>
      }
      @else{
      <div style="display: flex; justify-content: center; padding: 25px;">
        <h1>No mapped chains to this group</h1>
      </div>
      }

      @for (m of mappingsForSelectedGroup; track $index) {
      <div style="padding:10px;">
        • {{ m.Chain + " (" + (m.PriceListId ?? "Not Found") + ")" }}
        <button (click)="removeMappingPrieList(m)" mat-icon-button>
          <mat-icon style="color:red">close_small</mat-icon>
        </button>
      </div>
      }

    </div>
    }
    @else if(selectedGroupId == null && selectedPriceListTitle != null){
    @if (mappingsForSelectedPriceList?.length > 0) {
    <h1>Current Groups</h1>
    @for (m of mappingsForSelectedPriceList; track $index) {
    <div style="padding:10px;">
      • {{ m.GroupName + " ("+ m.T4GroupId +")" }}
      <button (click)="removeMappingGroup(m)" mat-icon-button a>
        <mat-icon style="color:red">close_small</mat-icon>
      </button>
    </div>
    }
    }
    @else{
    <div style="display: flex; justify-content: center; padding: 25px;">
      <h1>No mapped groups to this chain</h1>
    </div>
    }
    }
    @else if(selectedGroupId != null && selectedPriceListTitle != null){
    @if(selectedMappingExists){
    <h1>Mapping already exist</h1>
    }
    @else{
    @if(!loadingSaving){
    <div style="display: flex; justify-content: center; padding: 25px;">
      <button mat-raised-button color="primary" (click)="createMapping()">Create Connection</button>
    </div>
    }
    @else if(loadingSaving){
    <div style="display: flex; justify-content: center; padding: 25px;">
      <mat-spinner></mat-spinner>
    </div>
    }
    }
    }

    }
    @if (loading) {
    <mat-progress-bar mode="indeterminate" style="margin-left: -15px; position: absolute; width: calc(100% + 30px); top: 0px;"></mat-progress-bar>
    }
  </t4-container>
</mat-dialog-content>

